// TODO: Refactor this component by move some functions out to the other files.

import React from "react"
import _ from "lodash"
import { SortEnd } from "react-sortable-hoc"
import arrayMove from "array-move"
import Form from "react-bootstrap/Form"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"

import { GetApi } from "../../../../../api/api"
import { LegalAttributeValue, StreamVersions } from "../../../../../api/types"
import { UiTypes, ApiToUi, UiToApi } from "./UIModel"
import { Feedback } from "../../../../../components/Validator"
import AppContext from "../../../../../components/AppContext"
import withModal, {
  WithModalProps,
  InjectedProps,
} from "../../../../../components/HOC/WithModal"
import StepForm, { Step } from "../../../../../components/StepForm"
import Pending from "../../../../../components/Pending"

import { disableIfIntroducedInPreviousVersionOrOverride } from "../../../../../components/disableInputPolicy"
import AttributeTypeValidator from "./AttributeTypeValidator"
import DecimalNumberValidator from "./DecimalNumberValidator"
import NumberValidator from "./NumberValidator"
import DropdownChoiceValidator from "./DropdownChoiceValidator"
import ConfigureDecimalNumber from "./ConfigureDecimalNumber"
import ConfigureNumber from "./ConfigureNumber"
import ConfigureText from "./ConfigureText"
import ConfigureDropdownChoice from "./ConfigureDropdownChoice"
import ConfigureMeasureNumber from "./ConfigureMeasureNumber"

const nameId = "nameInputProperty"
const dataTypeId = "dataTypeSelectProperty"

interface InnerEditProps extends EditProps {
  attributeType: UiTypes.CustomAttributeType
  legalValues: LegalAttributeValue[]
}

interface InnerEditState {
  attributeType: UiTypes.CustomAttributeType
  enumLegalValues: LegalAttributeValue[]
  enumLegalValue: string
  // defaultEnumLegalValue: string
  valid: Feedback
  disabled: boolean
}

class InnerEdit extends React.Component<InnerEditProps, InnerEditState> {
  public static contextType = AppContext

  constructor(props: InnerEditProps) {
    super(props)
    this.state = {
      attributeType: props.attributeType,
      enumLegalValues: props.legalValues,
      enumLegalValue: "",
      // defaultEnumLegalValue:
      //   props.legalValues.find(lv => lv.primary)?.id.toString() || "",
      valid: props.valid,
      disabled: props.disabled,
    }
  }

  public componentDidUpdate(prevProps: InnerEditProps) {
    if (!_.isEqual(prevProps, this.props)) {
      this.setState({
        valid: this.props.valid,
        disabled: this.props.disabled,
      })
    }
  }

  public render() {
    const renderConfigurePane = (at: UiTypes.CustomAttributeType) => {
      switch (at.dataType) {
        case "Measure Number":
          return (
            <ConfigureMeasureNumber
              default={this.state.attributeType.defaultValue}
              min={this.state.attributeType.minValue}
              max={this.state.attributeType.maxValue}
              decimalDigits={this.state.attributeType.numberOfDecimals}
              valid={this.state.valid}
              disabled={this.state.disabled}
              measureType={ApiToUi.convertMeasureType(this.state.attributeType.measureType)}
              setDisabled={this.setDisabled}
              onUpdate={this.updateAttributeType}
              setDefault={this.setNumberDefaultValue}
              setMin={this.setNumberMinValue}
              setMax={this.setNumberMaxValue}
              setDecimalDigits={this.setDecimalDigits}
              setMeasureType={this.setMeasureType}
            />
          )
        case "Decimal Number":
          return (
            <ConfigureDecimalNumber
              default={this.state.attributeType.defaultValue}
              min={this.state.attributeType.minValue}
              max={this.state.attributeType.maxValue}
              decimalDigits={this.state.attributeType.numberOfDecimals}
              valid={this.state.valid}
              disabled={this.state.disabled}
              setDisabled={this.setDisabled}
              onUpdate={this.updateAttributeType}
              setDefault={this.setNumberDefaultValue}
              setMin={this.setNumberMinValue}
              setMax={this.setNumberMaxValue}
              setDecimalDigits={this.setDecimalDigits}
            />
          )
        case "Number":
          return (
            <ConfigureNumber
              default={this.state.attributeType.defaultValue}
              min={this.state.attributeType.minValue}
              max={this.state.attributeType.maxValue}
              valid={this.state.valid}
              disabled={this.state.disabled}
              setDisabled={this.setDisabled}
              onUpdate={this.updateAttributeType}
              setDefault={this.setNumberDefaultValue}
              setMin={this.setNumberMinValue}
              setMax={this.setNumberMaxValue}
            />
          )
        case "Text":
          return (
            <ConfigureText
              default={this.state.attributeType.defaultValue}
              valid={this.state.valid}
              disabled={this.state.disabled}
              setDisabled={this.setDisabled}
              onUpdate={this.updateAttributeType}
              setDefault={this.setNumberDefaultValue}
            />
          )
        case "Dropdown Choice":
          return (
            <ConfigureDropdownChoice
              fccId={this.props.fccId}
              atId={this.props.atId}
              value={this.state.enumLegalValue}
              default={this.state.attributeType.defaultValue}
              legalValues={this.state.enumLegalValues}
              currentVersion={this.props.currentVersion}
              // tslint:disable-next-line: jsx-no-lambda
              refresh={async () => {
                const api = await GetApi()
                const legalValues = await api.getAttributeLegalValues(
                  this.props.fccId,
                  this.props.atId
                )
                this.setState({
                  enumLegalValues: legalValues
                    .map((lv) => ({ ...lv, no: lv.no || 0 }))
                    .sort((a, b) => a.no - b.no),
                })
              }}
              valid={this.state.valid}
              disabled={
                (!this.state.attributeType.hasLegalValues &&
                  disableIfIntroducedInPreviousVersionOrOverride(
                    this.state.attributeType,
                    this.props.currentVersion,
                    this.state.disabled
                  )) ||
                this.state.disabled
              }
              setDisabled={this.setDisabled}
              onAdd={this.addLegalAttributeValue}
              onRemove={this.removeLegalAttributeValue}
              onSortEnd={this.sortLegalAttributeValues}
              setValue={this.setEnumAllowedValue}
              setDefault={this.setDefaultValue}
            />
          )
        default:
          return null
      }
    }

    return (
      <StepForm>
        <Step name="Basic information">{this.renderBasicInfo()}</Step>
        <Step
          name={`Configure ${this.state.attributeType.dataType.toLowerCase()}`}
        >
          {renderConfigurePane(this.state.attributeType)}
        </Step>
      </StepForm>
    )
  }

  public isVersionHigherOrEqual(fccStreamVersion: string, streamVersion: string) {
    if (fccStreamVersion === null || streamVersion === null) {
      return false;
    }
    const v1 = fccStreamVersion.split(".")
    const v2 = streamVersion.split('.')
    if (v1.length < 2 || v2.length <2) {
      return false;
    }

    const v1Major = parseInt(v1[0],10);
    const v1Minor = parseInt(v1[1],10);

    const v2Major = parseInt(v1[0],10);
    const v2Minor = parseInt(v2[1],10);

    return (v1Major > v2Major) ||
           (v1Major === v2Major && v1Minor >= v2Minor);
  }

  public renderBasicInfo = () => {
    const disabledName =
      this.state.disabled ||
      (!this.state.valid.valid && this.state.valid.id !== nameId)
    const disabledDataType = disableIfIntroducedInPreviousVersionOrOverride(
      this.state.attributeType!,
      this.props.currentVersion,
      this.state.disabled || !this.state.valid.valid
    )

    const inValidName = this.state.valid.id === nameId

    const getTypeOptions = (x: UiTypes.AttributeDataTypeOrGroup[]) =>
      x.map((adt, i) => {
        if (adt instanceof Object) {
          return (
            <optgroup key={`${i}_optgroup_${adt}`} label={adt.group}>
              {getTypeOptions(adt.types)}
            </optgroup>
          )
        // measure number are only available for fc stream versions higher than 4.211
        } else if (adt === "Measure Number" && !this.isVersionHigherOrEqual(this.props.maximumStreamVersion, StreamVersions.SV_4211)) { 
          return (
            <option key={`${i}_option_${adt}`} value={adt} disabled={true}>
              {adt} (Not available)
            </option>
          )
        } else {
          return (
            <option key={`${i}_option_${adt}`} value={adt}>
              {adt}
            </option>
          )
        }
      })

    return (
      <Form>
        {this.state.attributeType.introducedInVersion !==
          this.props.currentVersion && (
          <div className="message message-primary mb-md-4">
            <i className="modus-icons">info</i>
            Some elements of the property are not editable because the property
            has already been introduced in a previous feature catalog version.
          </div>
        )}

        <Form.Group as={Row} controlId={nameId}>
          <Form.Label column={true} md="3">
            Name <span className="text-danger">*</span>
          </Form.Label>
          <Col md="9">
            <Form.Control
              type="text"
              value={this.state.attributeType.name}
              onChange={this.setName}
              onBlur={this.updateAttributeType}
              disabled={disabledName}
              isInvalid={inValidName}
            />
            <Form.Control.Feedback type="invalid">
              {this.state.valid.message}
            </Form.Control.Feedback>
            <Form.Text>Name of the property.</Form.Text>
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId={dataTypeId}>
          <Form.Label column={true} md="3">
            Type <span className="text-danger">*</span>
          </Form.Label>
          <Col md="9">
            <Form.Control
              as="select"
              // className='custom-select'
              value={this.state.attributeType.dataType}
              onChange={this.setDataType}
              disabled={disabledDataType}
            >
              <option value={"Unknown"} disabled={true}>
                -- please select --
              </option>
              {getTypeOptions(UiTypes.AttributeDataTypes)}
            </Form.Control>
            <Form.Control.Feedback type="invalid">
              {this.state.valid.message}
            </Form.Control.Feedback>
            <Form.Text>The data type for the property.</Form.Text>
          </Col>
        </Form.Group>
      </Form>
    )
  }

  private updateAttributeType = async () => {
    if (this.state.valid.valid) {
      this.setDisabled(true)
      try {
        const api = await GetApi()
        await api.updateAttributeType(
          this.props.fccId,
          this.state.attributeType.id,
          UiToApi.convertAttributeType(this.state.attributeType)
        )
      } catch (error) {
        this.context.useToasts.addToast(error, "danger")
      } finally {
        this.setDisabled(false)
      }
    }
  }

  private addLegalAttributeValue = () => {
    this.setDisabled(true)
    GetApi()
      .then((api) =>
        api.addAttributeLegalValue(this.props.fccId, this.props.atId, {
          value: this.state.enumLegalValue,
          caption: this.state.enumLegalValue + "-", // Dirty fix for min length 2 requirement
          id: -1,
          introducedInVersion: 0,
          no:
            this.state.enumLegalValues.reduce(
              (p, n) => Math.max(p, n.no || 0),
              0
            ) + 1,
        })
      )
      .then((lv) =>
        this.setState((prevState) => ({
          enumLegalValues: [...prevState.enumLegalValues, lv].sort(
            (a, b) => a.no! - b.no!
          ),
          enumLegalValue: "",
        }))
      )
      .catch((error) => this.context.useToasts.addToast(error, "danger"))
      .finally(() => this.setDisabled(false))
  }

  private updateAllLegalAttributeValues = () => {
    GetApi()
      .then((api) =>
        api.updateAttributeLegalValues(
          this.props.fccId,
          this.props.atId!,
          this.state.enumLegalValues
        )
      )
      .catch((error) => this.context.useToasts.addToast(error, "danger"))
      .finally(() => this.setDisabled(false))
  }

  private sortLegalAttributeValues = (e: SortEnd) => {
    if (e.newIndex !== e.oldIndex) {
      this.setDisabled(true)
      this.setState(
        {
          enumLegalValues: arrayMove(
            this.state.enumLegalValues,
            e.oldIndex,
            e.newIndex
          ).map((lv, i) => ({ ...lv, no: i })),
        },
        () => this.updateAllLegalAttributeValues()
      )
    }
  }

  private removeLegalAttributeValue = (id: number) => {
    this.setDisabled(true)
    GetApi()
      .then((api) =>
        api.removeAttributeLegalValue(this.props.fccId, this.props.atId, id)
      )
      .then(() =>
        this.setState((prevState) => ({
          enumLegalValues: prevState.enumLegalValues
            .filter((lv) => lv.id !== id)
            .sort((a, b) => a.no! - b.no!),
        }))
      )
      .catch((error) => this.context.useToasts.addToast(error, "danger"))
      .finally(() => this.setDisabled(false))
  }

  private setName = (e: any) => {
    e.persist()
    const isValid = AttributeTypeValidator.getFieldValidator("name")(
      nameId,
      e.target.value
    )
    this.setState(
      (prevState) => ({
        attributeType: {
          ...prevState.attributeType,
          name: e.target.value,
        },
        valid: isValid,
      }),
      () => this.props.setValid(isValid)
    )
  }

  private setDataType = async (e: any) => {
    e.persist()
    const value = e.target.value
    if (this.state.enumLegalValues.length > 0) {
      // if has allowed values...
      const result = await window.confirm(
        "Changing value type will delete all allowed values. Proceed?"
      )
      if (result) {
        try {
          const api = await GetApi()
          const legalValues = await api.getAttributeLegalValues(
            this.props.fccId,
            this.state.attributeType!.id
          )
          await Promise.all(
            legalValues.map((lv) =>
              api.removeAttributeLegalValue(
                this.props.fccId,
                this.state.attributeType!.id,
                lv.id!
              )
            )
          )
          this.setState(
            (prevState) => ({
              attributeType: {
                ...prevState.attributeType,
                dataType: value,
                minValue: undefined,
                maxValue: undefined,
                defaultValue: undefined,
                measureType: undefined,
              },
              enumLegalValues: [],
              enumLegalValue: "",
            }),
            () => this.updateAttributeType()
          )
        } catch (error) {
          this.context.useToasts.addToast(error, "danger")
        }
      }
    } else {
      this.setState(
        (prevState) => ({
          attributeType: {
            ...prevState.attributeType,
            dataType: value,
            minValue: undefined,
            maxValue: undefined,
            defaultValue: undefined,
            measureType: undefined,
          },
          enumLegalValues: [],
          enumLegalValue: "",
        }),
        () => this.updateAttributeType()
      )
    }
  }

  private setNumberDefaultValue = (
    id: string,
    e: any,
    valueType?: "Number" | "Decimal" | "Measure"
  ) => {
    e.persist()
    let isValid = { valid: true }
    switch (valueType) {
      case "Number":
        isValid = NumberValidator.getFieldValidator("default")(id, {
          value: e.target.value,
          min: this.state.attributeType.minValue,
          max: this.state.attributeType.maxValue,
        })
      case "Decimal":
        isValid = DecimalNumberValidator.getFieldValidator("default")(id, {
          value: e.target.value,
          min: this.state.attributeType.minValue,
          max: this.state.attributeType.maxValue,
        })
      case "Measure":
          isValid = DecimalNumberValidator.getFieldValidator("default")(id, {
          value: e.target.value,
          min: this.state.attributeType.minValue,
          max: this.state.attributeType.maxValue,
          measureType: this.state.attributeType.measureType,
        })
    }
    this.setState(
      (prevState) => ({
        attributeType: {
          ...prevState.attributeType,
          defaultValue:
            e.target.value.length > 0
              ? valueType
                ? (+e.target.value).toString()
                : e.target.value
              : undefined,
        },
        valid: isValid,
      }),
      () => this.props.setValid(isValid)
    )
  }

  private setNumberMinValue = (
    id: string,
    e: any,
    isDecimal: boolean = false
  ) => {
    e.persist()
    const isValid = isDecimal
      ? DecimalNumberValidator.getFieldValidator("min")(id, {
          value: e.target.value,
          max:
            this.state.attributeType.defaultValue ||
            this.state.attributeType.maxValue,
        })
      : NumberValidator.getFieldValidator("min")(id, {
          value: e.target.value,
          max:
            this.state.attributeType.defaultValue ||
            this.state.attributeType.maxValue,
        })
    this.setState(
      (prevState) => ({
        attributeType: {
          ...prevState.attributeType,
          minValue:
            e.target.value.length > 0
              ? (+e.target.value).toString()
              : undefined,
        },
        valid: isValid,
      }),
      () => this.props.setValid(isValid)
    )
  }

  private setNumberMaxValue = (
    id: string,
    e: any,
    isDecimal: boolean = false
  ) => {
    e.persist()
    const isValid = isDecimal
      ? DecimalNumberValidator.getFieldValidator("max")(id, {
          value: e.target.value,
          min:
            this.state.attributeType.defaultValue ||
            this.state.attributeType.minValue,
        })
      : NumberValidator.getFieldValidator("max")(id, {
          value: e.target.value,
          min:
            this.state.attributeType.defaultValue ||
            this.state.attributeType.minValue,
        })
    this.setState(
      (prevState) => ({
        attributeType: {
          ...prevState.attributeType,
          maxValue:
            e.target.value.length > 0
              ? (+e.target.value).toString()
              : undefined,
        },
        valid: isValid,
      }),
      () => this.props.setValid(isValid)
    )
  }

  private setDecimalDigits = (id: string, digits: number) => {
    this.setState((prevState) => ({
      attributeType: {
        ...prevState.attributeType,
        numberOfDecimals: digits,
      },
    }))
  }

  private setMeasureType = (id: string, type: any) => {
    type.persist()
    this.setState((prevState) => ({
      attributeType: {
        ...prevState.attributeType,
        measureType: type.target.value,
      },
    }))
  }

  private setEnumAllowedValue = (id: string, e: any) => {
    e.persist()
    const isValid = DropdownChoiceValidator.getFieldValidator("value")(
      id,
      e.target.value
    )
    this.setState(
      {
        enumLegalValue: e.target.value,
        valid: isValid,
      },
      () => this.props.setValid(isValid)
    )
  }

  private setDisabled = (value: boolean) => {
    this.props.setDisabled(value)
    this.setState({
      disabled: value,
    })
  }

  private setDefaultValue = (defaultValue: string, e: any) => {
    e.persist()
    const theValue = this.state.enumLegalValues.find(v => v.id === parseInt(e.target.value, 10))
    this.setState((prevState) => ({
      attributeType: {
        ...prevState.attributeType,
        defaultValue: theValue?.value,
      },
    }))
    this.updateAttributeType()
  }
}

interface EditProps extends InjectedProps {
  atId: number
  fccId: string
  atgId: number
  currentVersion: number
  maximumStreamVersion: string
}

const Edit = (props: EditProps) => {
  const getData = async (): Promise<InnerEditProps> => {
    const api = await GetApi()
    const [attributeType, legalValues] = await Promise.all([
      api.getAttributeType(props.fccId, props.atId),
      api.getAttributeLegalValues(props.fccId, props.atId),
    ])
    return {
      ...props,
      attributeType: ApiToUi.convertAttributeType(attributeType),
      legalValues: legalValues
        .map((lv) => ({ ...lv, no: lv.no || 0 }))
        .sort((a, b) => a.no - b.no),
    }
  }

  const renderSuccess = (innerProps: InnerEditProps) => (
    <InnerEdit {...innerProps} />
  )

  return <Pending getData={getData} renderSuccess={renderSuccess} />
}

export interface EditModalProps extends WithModalProps {
  atId: number
  fccId: string
  atgId: number
  currentVersion: number
}

const EditModal = withModal(Edit)

export default EditModal
